module.exports = __webpack_public_path__ + "core-img/pointer.334c1646eb28892c9b5290fd312cc3f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/pointer.png
// module id = 119
// module chunks = 0